import { Injectable } from '@angular/core';
import { ConsumeCredencialesService } from '../generico/servicio/consume-credenciales.service';
import { MensajeService } from '../generico/servicio/mensaje.service';
import { SpinnerService } from '../spinner.service';
import { Aplicacion } from '../_models/aplicacion';
import { TreeAccionMenuComponent } from '../tree-accion-menu/tree-accion-menu.component';

@Injectable({
  providedIn: 'root'
})
export class AccionesService {

  aplicacion : Aplicacion;
  id_accion : number;
  dialog_ref : any;
  datos_accion : any ;
  tree_menu : TreeAccionMenuComponent;

  constructor(
    private cred_serv: ConsumeCredencialesService,
    private msjserv : MensajeService,
    private spin : SpinnerService,
  ) { }

  /**
   * Funcion que consulta los menus de una aplicacion 
   * @param data_form parametros para la consulta.
   */
  async consultar_menus(data_form){

    const promesa = this.cred_serv.post('obtenerMenus', data_form).toPromise();

    await promesa.then(
      (data : any )=>{
        this.spin.spin$.next(false);
        if(data.code > 0){
          this.msjserv.ver_mensaje(data.msg, '', this.msjserv.TIPO_ERROR);
        }else{

          this.aplicacion.menu = data.data.menu;

        }

      }
    );

  }
  
  /**
   * consulta una accion en especifico.
   * @param id_accion id de la accion a consultar
   */
  async consultar_accion(id_accion :number){
    const promes = this.cred_serv.get('obtenerAcciones/'+id_accion).toPromise(); 

    await promes.then(
      (data : any)=>{
        this.spin.spin$.next(false);

        if(data.code >0){
          this.msjserv.ver_mensaje(data.msg, '', this.msjserv.TIPO_ERROR);
        }else{
          this.datos_accion = data.data[0];
        }

      }
    );
  }

  /**
   * * Funcion que se encarga de gestionar las acciones que se crear
   * @param data_form : datos para la creacion de la accion
   */
  gestionar_accion(data_form){

    this.cred_serv.post('gestionarAccion', data_form)
        .subscribe(
          (data: any)=>{
            this.spin.spin$.next(false);
            let tipo_mensaje = this.msjserv.TIPO_OK;

            if (data.code > 0){
              tipo_mensaje = this.msjserv.TIPO_ERROR;
            }

            this.msjserv.ver_mensaje(data.msg, '', tipo_mensaje)
                .afterClosed()
                .subscribe(
                  ()=>{
                    if(data.code == 0 && this.dialog_ref){
                      this.dialog_ref.close();
                    }
                  }
                );

          }
        );

  }
}
